package com.example.mystybag.appCore.model


/**
 * Тип превключвател в екрана настройки на известия.
 * При натискане на превключвател се извиква командата с един от тези типове.
 */
sealed class NotificationSettingToggle {
    data object ReservationCompletedPush : NotificationSettingToggle()
    data object ReservationCompletedEmail : NotificationSettingToggle()
    data object DiscountsAndNewsPush : NotificationSettingToggle()
    data object DiscountsAndNewsEmail : NotificationSettingToggle()
}
